import { Controller } from "@hotwired/stimulus"
import { pluralize, dynos } from "../../lib/helpers"
import { reactor } from "../../lib/reactor"

export default class extends Controller {
  static values = {
    minimum: Number,
    maximum: Number,
    off: Boolean,
    wakesFromZero: { type: Boolean, default: true },
  }

  connect() {
    reactor(this)
  }

  toggleOff({ target }) {
    if (target.checked) {
      this.bounds = [this.minimumValue, this.maximumValue]
      this.minimumValue = 0
      this.maximumValue = 0
    } else {
      const [minimum, maximum] = this.bounds?.[1] > 0 ? this.bounds : [this.wakesFromZeroValue ? 0 : 1, 1]
      this.minimumValue = minimum
      this.maximumValue = maximum
    }

    this.offValue = target.checked
  }

  minimumDescription() {
    if (this.minimumValue === 0 && !this.wakesFromZeroValue)
      return `This process can't scale up from ${dynos("0 dynos")}. Use Off to keep it at 0 for this window.`

    if (this.minimumValue === 0)
      return `Can scale down to ${dynos("0 dynos")} during this schedule.`

    return `Won't scale below ${dynos(pluralize(this.minimumValue, "{{n}} dyno", "{{n}} dynos"))} during this schedule.`
  }

  maximumDescription() {
    return `Won't scale above ${dynos(pluralize(this.maximumValue, "{{n}} dyno", "{{n}} dynos"))} during this schedule.`
  }
}
